module.exports = __webpack_public_path__ + "img/iga.ddda1a98.svg";